import ColorJS from "colorjs.io";
export const Direction = {
    North: "north",
    East: "east",
    South: "south",
    West: "west",
};
export const Color = {
    Black: "black",
    Red: "red",
    Green: "green",
    Blue: "blue",
    Yellow: "yellow",
};
const COLOR_TO_HEX = {
    [Color.Black]: "#000000",
    [Color.Red]: "#e53e3e",
    [Color.Green]: "#38a169",
    [Color.Blue]: "#3182ce",
    [Color.Yellow]: "#d69e2e",
};
export function toHex(rawColor) {
    return new ColorJS(rawColor in COLOR_TO_HEX ? COLOR_TO_HEX[rawColor] : rawColor).toString({ format: "hex" });
}
export const Shape = {
    None: "none",
    Square: "square",
    Circle: "circle",
};
export function defineDancers(dancers) {
    return dancers;
}
export function resolveDancer(dancer) {
    const r = { ...dancer };
    r.direction = Array.isArray(r.direction)
        ? r.direction
        : r.direction
            ? [r.direction]
            : [];
    r.label ??= "";
    r.phantom ??= false;
    r.rotate ??= 0;
    if (r.color) {
        r.color = toHex(r.color);
    }
    return r;
}
//# sourceMappingURL=dancer.js.map